import config from "./config.json";

export default Object.assign({}, config, {
    api_url: process.env.VUE_APP_URL,
    access_token_url: process.env.VUE_APP_URL + '/auth',
    brandName: process.env.VUE_APP_BRAND_CLIENT_ID,
})
